export class AxiosResultStatus {
    entity!: any;
    hasErrors!: boolean;
    errorMessage: string = "";
    statusCode?: number;
  }